import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '../contexts/AuthContext';
import { ChevronLeft } from 'lucide-react';
import { PRODUCTOS } from '../constants/productos';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function VerInventario() {
  const { user } = useAuth();
  const navigate = useNavigate();
  
  const [inventario, setInventario] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadInventario();
  }, []);

  const loadInventario = async () => {
    try {
      const { data } = await axios.get(`${API}/inventario/actual/${user.punto_venta_id}`);
      setInventario(data.productos || {});
    } catch (error) {
      console.error('Error loading inventory:', error);
    } finally {
      setLoading(false);
    }
  };

  const getTotalPiezas = () => {
    return Object.values(inventario).reduce((sum, qty) => sum + (qty || 0), 0);
  };

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-white">
        <span className="inline-block w-8 h-8 border-2 border-zinc-300 border-t-zinc-600 rounded-full animate-spin" />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-white flex flex-col" data-testid="ver-inventario-page">
      {/* Header */}
      <div className="px-4 py-3 border-b border-zinc-200">
        <div className="flex items-center gap-3">
          <button
            onClick={() => navigate('/pos')}
            className="w-10 h-10 flex items-center justify-center border border-zinc-300 rounded-lg"
            data-testid="btn-back"
          >
            <ChevronLeft className="w-5 h-5" />
          </button>
          <h1 className="text-xl font-bold text-zinc-900">Inventario Actual</h1>
        </div>
      </div>

      {/* Content */}
      <div className="flex-1 px-6 py-4">
        <div className="space-y-1">
          {PRODUCTOS.map((producto) => {
            const qty = inventario[producto.clave] || 0;
            const isLow = qty <= 5;
            const isCritical = qty === 0;
            
            return (
              <div
                key={producto.clave}
                className={`flex items-center justify-between py-4 border-b border-zinc-100 ${
                  isCritical ? 'bg-red-50 -mx-6 px-6' : ''
                }`}
                data-testid={`inventario-${producto.clave}`}
              >
                <span className="text-lg font-medium text-zinc-900">{producto.nombre}</span>
                <span className={`text-2xl font-bold ${
                  isCritical ? 'text-red-600' : isLow ? 'text-orange-600' : 'text-zinc-900'
                }`}>
                  {qty}
                </span>
              </div>
            );
          })}
        </div>

        {/* Total */}
        <div className="flex items-center justify-between py-4 mt-4 bg-zinc-100 -mx-6 px-6">
          <span className="text-lg font-bold text-zinc-900">Total piezas</span>
          <span className="text-3xl font-bold text-zinc-900">{getTotalPiezas()}</span>
        </div>
      </div>
    </div>
  );
}
